import { z } from 'zod';

export const USER_INFO_BANNER_MESSAGES = [
  'operational_failure',
  'system_error',
  'service_disruption',
  'minor_disruption',
  'degraded_performance',
  'temporarily_affected',
  'problem_fixed',
] as const;

export type UserInfoBannerMessage = (typeof USER_INFO_BANNER_MESSAGES)[number];

export type UserInfoBannerSeverity = 'error' | 'warning' | 'info' | 'positive';

// `dismissable` (not "dismissible") is the exact key in the Confidence flag value.
// An unknown `banner.message` fails parsing, which hides the banner rather than
// rendering it unstyled.
export const userInfoBannerFlagSchema = z.object({
  banner: z.object({
    dismissable: z.boolean(),
    message: z.enum(USER_INFO_BANNER_MESSAGES),
  }),
});

export type UserInfoBannerFlagValue = z.infer<typeof userInfoBannerFlagSchema>;

export type ActiveUserInfoBanner = {
  message: UserInfoBannerMessage;
  severity: UserInfoBannerSeverity;
  dismissable: boolean;
};
